import React, { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useReducedMotion, useSpring } from "framer-motion";
import { PhoneIcon } from "lucide-react";
import { business } from "../../data/business";
type MagneticCallButtonProps = {
  label?: string;
  size?: "md" | "lg" | "xl";
  className?: string;
};
const sizes = {
  md: "min-h-[48px] px-5 text-[0.95rem]",
  lg: "min-h-[56px] px-7 text-lg",
  xl: "min-h-[64px] px-8 text-xl"
};
export function MagneticCallButton({
  label,
  size = "lg",
  className = ""
}: MagneticCallButtonProps) {
  const ref = useRef<HTMLAnchorElement>(null);
  const reduce = useReducedMotion();
  const [finePointer, setFinePointer] = useState(false);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, {
    stiffness: 260,
    damping: 20,
    mass: 0.4
  });
  const sy = useSpring(y, {
    stiffness: 260,
    damping: 20,
    mass: 0.4
  });
  useEffect(() => {
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    setFinePointer(mq.matches);
  }, []);
  const magnetic = finePointer && !reduce;
  function handleMove(e: React.MouseEvent<HTMLAnchorElement>) {
    if (!magnetic || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    x.set((e.clientX - (r.left + r.width / 2)) * 0.22);
    y.set((e.clientY - (r.top + r.height / 2)) * 0.3);
  }
  function reset() {
    x.set(0);
    y.set(0);
  }
  return <motion.a ref={ref} href={business.phoneHref} onMouseMove={handleMove} onMouseLeave={reset} style={magnetic ? {
    x: sx,
    y: sy
  } : undefined} className={`shimmer group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full bg-gold font-semibold text-navy shadow-gold transition-[background-color,box-shadow] duration-150 ease-out hover:bg-gold-hover hover:shadow-[0_12px_40px_-8px_rgba(201,162,74,0.7)] active:scale-[0.98] ${sizes[size]} ${className}`} data-id="element-427" data-mp="6agxshwddky9">
      <PhoneIcon className="h-5 w-5 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-428" data-mp="3epqvzex5260r" />
      <span data-id="element-429" data-mp="350k2aullxry5">{label ?? `Call ${business.phoneDisplay}`}</span>
    </motion.a>;
}